// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__gGw4n","modalContent":"styles_modalContent__-bZ1f","header":"styles_header__COkpp","title":"styles_title__osPyq","actions":"styles_actions__nLyO0"};